module.exports = `:root {
  --primitiveColorNeutralBase950: #f2f2ee;
  --primitiveColorNeutralDarker840: #d1d1c3;
  --primitiveColorNeutralDark910: #e7e7e0;
  --primitiveColorNeutralLight960: #f3f3f0;
  --primitiveColorNeutralLighter970: #f6f6f3;
  --primitiveColorPrimaryBase850: #ffcd05;
  --primitiveColorPrimaryDarker700: #cca404;
  --primitiveColorPrimaryDark790: #ebbc00;
  --primitiveColorPrimaryLight860: #ffd21e;
  --primitiveColorPrimaryLighter920: #ffe784;
  --primitiveColorPrimaryOpacity970: rgba(255,245,205,0.2);
  --primitiveColorSecondaryBase520: #008c80;
  --primitiveColorSecondaryDarker330: #005951;
  --primitiveColorSecondaryDark430: #007369;
  --primitiveColorSecondaryLight610: #33a399;
  --primitiveColorSecondaryLighter690: #00bfaf;
  --primitiveColorSecondaryOpacity900: rgba(204,232,230);
  --primitiveColorDarkBase250: #004346;
  --primitiveColorDarkDarker140: #002a2c;
  --primitiveColorDarkDark210: #00393c;
  --primitiveColorDarkLight340: #005b60;
  --primitiveColorDarkLighter440: #007479;
  --primitiveColorLightBase1000: #ffffff;
  --primitiveColorLightDarker930: #ebebeb;
  --primitiveColorLightDark970: #f5f5f5;
  --primitiveColorCorrectBase520: #008c80;
  --primitiveColorCorrectDarker270: #004a44;
  --primitiveColorCorrectDark420: #007065;
  --primitiveColorCorrectLight900: #cce8e6;
  --primitiveColorCorrectLighter950: #e5f3f2;
  --primitiveColorErrorBase410: #bd1903;
  --primitiveColorErrorDarker280: #841202;
  --primitiveColorErrorDark370: #aa1703;
  --primitiveColorErrorLight860: #f9ccc6;
  --primitiveColorErrorLighter930: #f8e8e6;
  --primitiveColorTextBase0: #000000;
  --primitiveColorTextLight430: #666666;
  --primitiveColorTextLighter630: #999999;
  --primitiveColorHighlightBase900: #ffe233;
  --primitiveColorHighlightDarker740: #e8a804;
  --primitiveColorHighlightDark860: #fad305;
  --primitiveColorHighlightLight950: #fff2a3;
  --primitiveColorHighlightLighter970: #fffad8;
  --primitiveColorBorderBase820: #cdcbc3;
  --primitiveColorBorderDarker520: #7f7d75;
  --primitiveColorBorderDark660: #a4a196;
  --primitiveColorBorderLight840: #d4d3ca;
  --primitiveColorBorderLighter880: #dcdcd1;
  --primitiveColorDisabledBase420: #656363;
  --primitiveColorDisabledDarker340: #515151;
  --primitiveColorDisabledDark380: #5b5a5a;
  --primitiveColorDisabledLight590: #8f8e8e;
  --primitiveColorDisabledLighter750: #b9b9b9;
  --primitiveColorWarningBase487: #c25100;
  --primitiveColorWarningDarker278: #702e00;
  --primitiveColorWarningDark422: #a54800;
  --primitiveColorWarningLight950: #fff1b8;
  --primitiveColorWarningLighter984: #fffbe6;
  --primitiveTypographyTypescale1: 3.125rem;
  --primitiveTypographyTypescale2: 2.375rem;
  --primitiveTypographyTypescale3: 2.0625rem;
  --primitiveTypographyTypescale4: 1.6875rem;
  --primitiveTypographyTypescale5: 1.4375rem;
  --primitiveTypographyTypescale6: 1.1875rem;
  --primitiveTypographyTypescale7: 1.0625rem;
  --primitiveTypographyTypescale8: 0.9375rem;
}
`;